export const tourOptions = {
  defaultStepOptions: {
    cancelIcon: {
      enabled: true,
    },
  },
  useModalOverlay: true,
}

const stepButtons = [
  {
    classes: ['button'],
    text: {
      defaultMessage: 'Back',
      id: 'djcity.common.intro.button.previous',
    },
    type: 'back',
  },
  {
    classes: ['button'],
    text: {
      defaultMessage: 'Next',
      id: 'djcity.common.intro.button.next',
    },
    type: 'next',
  },
]

const commonStepOptions = {
  arrow: false,
  buttons: stepButtons,
  cancelIcon: { enabled: true },
  classes: '',
  highlightClass: '',
  scrollTo: false,
}

export const steps = [
  {
    ...commonStepOptions,
    buttons: [stepButtons[1]],
    id: 'searchBox',
    attachTo: { element: 'div#songSearchBox', on: 'bottom' },
    title: {
      defaultMessage: 'Search Box',
      id: 'djcity.common.intro.one.title',
    },
    text: {
      defaultMessage: 'Search for your favorite artists, song or remixer name',
      id: 'djcity.common.intro.one.text',
    },
  },
  {
    ...commonStepOptions,
    id: 'catalog',
    attachTo: { element: 'nav>ul>div:first-of-type', on: 'bottom' },
    title: {
      defaultMessage: 'Full music catalog',
      id: 'djcity.common.intro.two.title',
    },
    text: {
      defaultMessage:
        'Browse the entire DJCity music catalog using the menu items here',
      id: 'djcity.common.intro.two.text',
    },
  },
  {
    ...commonStepOptions,
    id: 'actionMenu',
    attachTo: {
      element: '#homeSidebar div.songVersionsPopover1',
      on: 'top-start',
    },
    title: {
      defaultMessage: 'Action Menu',
      id: 'djcity.common.intro.four.title',
    },
    text: {
      defaultMessage: 'Use these icons to download or add songs to your crate',
      id: 'djcity.common.intro.four.text',
    },
    beforeShowPromise: function() {
      return new Promise(resolve => {
        const el1 = document.querySelector('#mostPopularTable>ul>div')
        const el2 = document.querySelectorAll('#mostPopularTable>ul>div>div')

        if (el1 && el2) {
          el1.style.backgroundColor = document.body.classList.contains(
            'darkMode'
          )
            ? '#242424'
            : '#F8F8F8'
          el2[2].style.visibility = 'visible'
          el2[3].style.visibility = 'visible'
        }
        resolve()
      })
    },
  },
  {
    ...commonStepOptions,
    id: 'actionMenu',
    attachTo: {
      element: '#homeSidebar div.songVersionsPopover2',
      on: 'top-start',
    },
    title: {
      defaultMessage: 'Action Menu',
      id: 'djcity.common.intro.seven.title',
    },
    text: {
      defaultMessage: 'Use these icons to download or add songs to your crate',
      id: 'djcity.common.intro.seven.text',
    },
    beforeShowPromise: function() {
      return new Promise(resolve => {
        const el1 = document.querySelector('#mostPopularTable>ul>div')
        const el2 = document.querySelectorAll('#mostPopularTable>ul>div>div')

        if (el1 && el2) {
          el1.style.backgroundColor = document.body.classList.contains(
            'darkMode'
          )
            ? '#242424'
            : '#F8F8F8'
          el2[2].style.visibility = 'visible'
          el2[3].style.visibility = 'visible'
        }
        resolve()
      })
    },
    hideOnMobile: true,
  },
  {
    ...commonStepOptions,
    id: 'crate',
    attachTo: { element: 'div#cratePopover', on: 'bottom' },
    title: {
      defaultMessage: 'Your Crate',
      id: 'djcity.common.intro.three.title',
    },
    text: {
      defaultMessage:
        'Find your saved songs here and bulk download them all using the Desktop App',
      id: 'djcity.common.intro.three.text',
    },
  },
  {
    ...commonStepOptions,
    id: 'tracklist',
    attachTo: { element: 'div#newReleasesSettings', on: 'bottom' },
    title: {
      defaultMessage: 'New Releases settings',
      id: 'djcity.common.intro.five.title',
    },
    text: {
      defaultMessage: 'Select your favorite music genres',
      id: 'djcity.common.intro.five.text',
    },
  },
  {
    ...commonStepOptions,
    buttons: [
      stepButtons[0],
      {
        classes: ['button'],
        text: {
          defaultMessage: 'Finish',
          id: 'djcity.common.intro.button.finish',
        },
        type: 'cancel',
      },
    ],
    id: 'filters',
    attachTo: { element: 'div#newReleasesFilter', on: 'bottom' },
    title: {
      defaultMessage: 'Filters',
      id: 'djcity.common.intro.six.title',
    },
    text: {
      defaultMessage:
        'Filter by key, BPM, version and more to find exactly what you are looking for',
      id: 'djcity.common.intro.six.text',
    },
  },
]

export default steps
